export enum EnvironmentName {
  Local = 'local',
  Test = 'test',
  Prod = 'prod',
}
